<div mat-button [matMenuTriggerFor]="menu" class="w-full">
  <ng-content></ng-content>
  <mat-menu class="app-tooltip" #menu="matMenu" xPosition="before">
    <ng-content select="[tooltip]"></ng-content>
  </mat-menu>
</div>
